import { render, staticRenderFns } from "./GeneratePurchaseRecord.vue?vue&type=template&id=4207e192&scoped=true&"
import script from "./GeneratePurchaseRecord.vue?vue&type=script&lang=js&"
export * from "./GeneratePurchaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./GeneratePurchaseRecord.vue?vue&type=style&index=0&id=4207e192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207e192",
  null
  
)

export default component.exports